"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _Box = _interopRequireDefault(require("../../Box"));

var _theme = _interopRequireDefault(require("../../../theme"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Link = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Link",
  componentId: "sc-1ge21ka-0"
})(["", " ", ""], function (props) {
  return props.cursor && "cursor: ".concat(props.cursor, ";");
}, function (props) {
  return "\n    text-decoration: none;\n    &:hover {\n      text-decoration: none;  \n      color: ".concat((0, _themeGet["default"])("color.".concat(props.hoverColor))(props), "\n    }\n  ");
});
Link.defaultProps = {
  theme: _theme["default"],
  cursor: 'pointer',
  color: 'blue.500',
  hoverColor: 'blue.800',
  as: 'a'
};

var _default = (0, _styledComponents.withTheme)(Link);

exports["default"] = _default;